/**
 * @author vishwadeep.kapoor
 * @desc all constants used in the commonents
 * @property
 *      @arg LINK_ for all constants for routes
 *      @arg ALERT_ for all the alerts
 */

/**
 * @description all contants for the routes
 */
export const LINK_HOME = '/';
export const LINK_ABOUTUS = '/aboutus';
export const LINK_RESTAURANTS_DEALS = '/restaurant-deals';
export const LINK_RESTAURANTS = '/restaurant-deals'; /** having related @func GET_RESTAURANT_LIST_LINK */
export const LINK_RESTAURANTS_DETAILS = '/restaurants/restaurant-details';
export const LINK_GIFTCARD_LIST = '/gift-cards';
export const LINK_SPECIAL_DEALS_AND_OFFERS = '/special-deals-and-offers';
export const LINK_GIFTCARD_DETAILS = '/products';
export const LINK_MY_PROFILE = '/accounts/my-profile';
export const LINK_MY_BOOKINGS = '/my-bookings';
export const GIFT_CARD_CART = '/cart';
export const LINK_LOGIN = '/app-login';
export const LINK_MANAGE_ZAGGLE_CARD = '/payments';
export const LINK_PAY_BALANCE = '/pay-balance';
export const LINK_MY_ORDERS = '/orders';
export const LINK_ZAGGLE_CARD_DEAILS = '/card-details';
export const LINK_REDEEM_ZSC = '/redeem';
export const LINK_GIFTCARD_LANDING = '/gift-card-deals';
export const LINK_CONFIRM = '/confirm'; /** having related @func GET_LINK_CONFIRM */
export const LINK_ORDER_SUMMARY = '/order-summary';
export const LINK_SEARCH_RESULT = '/searchResult';
export const LINK_PAYU_SUCCESS = '/payuSuccess';
export const LINK_PAYU_FAIL = '/payuFail';
export const LINK_MOBIKWIK = '/mobikwikPayment';
export const LINK_CONTACT_US = '/contactus';
export const LINK_DELHIVERY_ADDRESS = '/delivery-address';
export const LINK_TERMS_CONDITIONS = '/terms-and-conditions';
export const LINK_REFUND_POLICY = '/refund-policy';
export const LINK_PRIVACY_POLICY = '/privacy-policy';
export const LINK_GRIEVANCE_POLICY = '/grievance-policy';
export const LINK_FAQS = '/faq';
export const LINK_ZINGER_CARD = '/expensemanagement';
export const LINK_PREPAID_CARD = '/prepaid-gift-cards';
export const LINK_REWARD_PLATFROM = '/rewards-platform';
export const LINK_MY_EVOUCHERS = '/my-e-gift-cards';
export const LINK_ZAGGLE_CARD = '/zaggle-card/activate';
export const LINK_SET_TOKEN = '/set-token';
export const LINK_E_VOUCHERS = '/evouchers';
export const LINK_PARTNER_WITH_US = '/partner';
export const LINK_CORPORATE_WEBSITE = '/corporate';
export const LINK_OLDPRESS = '/old-press';
export const LINK_PROPEL = 'https://www.zagglepropel.com/';
export const LINK_ZAGGLE_PORTAL = 'https://dev-portal.zaggle.in/';
// export const LINK_EDGE = '/coporate-gifting';
export const LINK_EDGE = 'https://www.zaggleedge.com/';
export const LINK_SAVE = 'https://www.zagglesave.com/';
export const LINK_EMS = 'https://www.zaggleems.com/';
export const LINK_TAXSPANNER = 'https://www.zaggle.in/taxspanner';
export const LINK_WEARABLES_ = 'https://www.zaggle.in/wearables';
export const LINK_ZERO_TO_IPO = 'https://www.zaggle.in/resources/zero-to-ipo-series';
export const LINK_ZAGGLEZOYER = 'https://zoyer.zaggle.in/';
export const LINK_FOUNDERSCARD = 'https://www.founderscard.in/';
export const LINK_NEOBANK = 'https://www.zikzuk.com/';
export const LINK_XPNS = 'https://www.xpns.com/';
export const LINK_CALCULATOR = '/expens‌e-management/value-calculat‌or‌';
export const LINK_PROPEL_OVERVIEW = 'https://www.zagglepropel.com/';
export const LINK_PROPEL_SOLUTIONS = 'https://www.zagglepropel.com/solutions';
export const LINK_PROPEL_PRICING = 'https://www.zagglepropel.com/pricing';
export const LINK_PROPEL_SUPPORT = 'https://www.zagglepropel.com/support';
export const LINK_PROPEL_SIGNUP = 'https://www.zagglepropel.com/?type=signup';
export const LINK_SAVE_OVERVIEW = 'https://www.zagglesave.com/';
export const LINK_SAVE_SIGNIN = 'https://www.zagglesave.com/?type=login';
export const LINK_SAVE_SIGNUP = 'https://www.zagglesave.com/?type=signup';
export const LINK_SAVE_SCHEDULE_A_DEMO = 'https://zagglesave.com/schedule-demo';
export const LINK_ZAGGLE_CREDIT_CARDS = 'https://zagglecards.com/';
export const LINK_ABOUT_US = '/about-us';
export const LINK_TEAM = '/team';
export const LINK_ANNUAL_GENERAL_MEETING = '/investor-relations';
export const LINK_INVESTOR_RELATIONS = 'https://ir.zaggle.in/';
export const LINK_TRUST_CENTER = 'https://trust.zaggle.in/';
export const LINK_MCMD = '/mcmd';
export const LINK_DISCLOSURES_REGULATION = '/disclosures-regulation';
export const LINK_MERCHANT = '/merchant';
export const LINK_CAREERS = '/careers';
export const LINK_PRESS = '/press';
export const LINK_CEDITCARD = '/creditcard';
export const LINK_NEWS_INTERNAL = '/news-internal';
export const LINK_CONTACTUS = '/contact-us';
export const LINK_THANKYOU = '/thank-you';
export const LINK_REWARDS_RECOGINITION = '/rewards-recognition-campaign';
export const LINK_EXPENSE_BENIFIT = '/expense-management-campaign';
export const LINK_CORPORATE_GIFT = '/corporate-gifting-campaign';
export const LINK_REWARDS_RECOGINITION_HTML = '/rewards-recognition-campaign.html';
export const LINK_EXPENSE_BENIFIT_HTML = '/expense-management-campaign.html';
export const LINK_CORPORATE_GIFT_HTML = '/corporate-gifting-campaign.html';
export const LINK_BLOG = 'https://zaggle.in/blog/';
export const LINK_CLIENT_MANIPAL = '/manipalcigna';
const LINK_ACCOUNT_CREATION = '/accounts/account-creation';
const LINK_ACCOUNT_ACTIVATE = '/accounts/activate-cards';
export const LINK_NEW_LANDING = '/newlanding';
export const LINK_EDGE_PRODUCTS = '/corporate-gifting/';
export const SETPOSPIN = '/setpospin'; // New Route For SetPosPin
export const CHANGE_INTERNET_PIN = '/changeinternetpin'; // New Route For ChangeInternetPin
export const LINK_SOLUTIONS = '/solutions/:type'; // New Route For Solutions
export const LINK_PARTNERS_MOBILE = '/partner-banners/:id'; // New Route For Solutions
export const LINK_SOLUTIONS_STARTUP = '/solutions/startup'; // New Route For Solutions STARTUP
export const LINK_SOLUTIONS_SME = '/solutions/sme'; // New Route For Solutions SME
export const LINK_SOLUTIONS_CORPORATE = '/solutions/corporate'; // New Route For Solutions Corporate
export const LINK_ZAGGLE_CARD_M2P = '/card-details-nsdl';
export const YBL_MIN_KYC = '/ybl-min-kyc';
export const AUDIT_COMMITTEE = '/board-committees';
export const LINK_ZAGGLE_OVERVIEW = '/zaggle-overview';
export const ANNUAL_REPORTS_IPO = '/annual-reports';
export const BOARD_OF_DIRECTORS = '/board-of-directors';
export const DIRECTORS_PROFILE = '/board-of-directors/:type';
export const FINANCIALS = '/financials';
export const DISCLOSURE_EVENTS_INFORMATION = '/disclosure-of-events-or-information';
export const FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER = '/financial-results-published-newspaper';
export const DISCLOSURES_REGULATION_GENERAL_MEETINGS = '/disclosures-regulation/general-meetings';
export const APP_LOGIN = '/login';
export const LINK_BROME = 'https://zoyer.zaggle.in/brome';
export const ZAGGLE_EMPLOYEE_PURCHASE_PROGRAM = 'https://www.zaggle.in/employee-purchase-program';
export const ZAGGLE_INTERNATIONAL_PAYMENTS = 'https://www.zaggle.in/international-payments';
export const ZAGGLE_CLOSED_LOOP_CARDS = 'https://www.zaggle.in/closed-loop-cards';
export const TERMS_AND_CONDITIONS = 'https://www.zaggle.in/terms-and-conditions';
export const PRIVACY_POLICY = 'https://www.zaggle.in/privacy-policy';
export const ABOUT_US = 'https://www.zaggle.in/about-us';
export const ZAGGLE_SAVE = 'https://www.zagglesave.com';
export const CAREERS = 'https://www.zaggle.in/careers';
export const PRESS = 'https://www.zaggle.in/press';
export const CONTACT_US = 'https://www.zaggle.in/contact-us';
export const GRIVANCE_POLICY = 'https://www.zaggle.in/grievance-policy';
export const REFUND_POLICY = 'https://www.zaggle.in/refund-policy';
export const FAQS = 'https://www.zaggle.in/faq';
export const ANDROID_APP = 'https://play.google.com/store/apps/details?id=com.zaggle&hl=en';
export const IOS_APP = 'https://itunes.apple.com/in/app/zaggle-restaurant-cashbacks/id1030365320?mt=8';
export const INVESTOR_RELATIONS = 'https://ir.zaggle.in/';
export const SOLUTIONS_MID_RANGE_COMPANIES = 'https://www.zaggle.in/solutions/mid-sized-companies';
export const SOLUTIONS_CORPORATE = 'https://www.zaggle.in/solutions/corporate';
export const TRUST_CENTER = 'https://trust.zaggle.in/';

// Routes For Lyra PG Integration
export const LYRA_PG_LOGIN = '/giftvouchers';
export const LYRA_PG_LINK_GIFTCARD_LIST = '/gift-cards/giftvouchers';
export const LYRA_PG_PAYMENT_STATUS = '/payment-status';

export const LINK_PAYROLL_CARD = '/payroll-card'; // New Route For Pay Roll Card
export const LINK_PAYROLL_CARD_CONTACT = '/payroll-card/contact-us'; // New Route For Pay Roll Card Contact

export const MANIPAL_CIGNA_HOME = 'https://cigna.corpmerchandise.com/Default.aspx';
export const MANIPAL_CIGNA_MAIN = 'https://www.manipalcigna.com';
export const YES_BANK_TERMS_AND_CONDITIONS = 'https://www.yesbank.in/';
export const YES_BANK_MITC = 'https://www.zaggle.in/terms-and-conditions#yes-bank-prepaidcards';

export const CAREER_MAIL = 'mailto:careers@zaggle.in';
export const CAMPAIGN_MONEYFY = '/moneyfy';
export const CAMPAIGN_GROW_MONEYFY = '/growwithmoneyfy';
export const CAMPAIGN_SECURE_MONEYFY = '/securewithmoneyfy';

export const LINK_MANIPAL_ABOUTUS = '/manipalcigna/about-us';
export const LINK_MANIPAL_REFUN_RETURN_POLICY = '/manipalcigna/refund-returnpolicy';
export const LINK_WEARABLES = '/wearables'; // New Route For Wearables


export const LINK_PROPEL_CORPORATE_GIFITING = '/propel-corporategifting';
const LINK_PROPEL_CORPORATE_GIFITING_HOME = '/propel-corporategifting-home';

const ROUTE_CONSTANTS = {
  COMPLAINT_MODULE: '/complaint-module',
  LINK_FUND_TRANSFER: '/pay-balance/card-details/fund-transfer',
  LINK_NSDL_FUND_TRANSFER: '/pay-balance/card-details/fund-transfer-nsdl',
  YES_BANK_WEARABLES_FAQS: '/yes-bank-wearables/faq',
  YBL_EXISTING_USERS: '/ybl/existing-users',
};

// Static Links Start //

export const NEXT_LINK_ABOUT_US = 'https://www.zaggle.in/about-us';
export const NEXT_LINK_TEAM = 'https://www.zaggle.in/team';
export const NEXT_LINK_CAREERS = 'https://www.zaggle.in/careers';
export const NEXT_LINK_PRESS = 'https://www.zaggle.in/press';
export const NEXT_LINK_PARTNER_WITH_US = 'https://www.zaggle.in/partner';
export const NEXT_LINK_CONTACT_US = 'https://www.zaggle.in/contact-us';
export const NEXT_LINK_GREIVANCE_POLICY = 'https://www.zaggle.in/grievance-policy';
export const NEXT_LINK_TERMS_CONDITIONS = 'https://www.zaggle.in/terms-and-conditions';
export const NEXT_LINK_PRIVACY_POLICY = 'https://www.zaggle.in/privacy-policy';
export const NEXT_LINK_REFUND_POLICY = 'https://www.zaggle.in/refund-policy';
export const NEXT_LINK_FAQS = 'https://www.zaggle.in/faq';
export const NEXT_LINK_MID_SIZED_COMPANIES = 'https://www.zaggle.in/solutions/mid-sized-companies';
export const NEXT_LINK_SOLUTONS_CORPORATE = 'https://www.zaggle.in/solutions/corporate';

// Static Links End //

export const LINK_CAMPAIGN_MONEYFY = 'https://www.tatacapital.com/moneyfy/?cid=affiliate:moneyfyMf:Zaggle::#';
export const LINK_FOREX_SERVICES = 'https://fpaas.wsfx.in/?utm=UEEyNjI4';

// Home page news
export const LINK_NEWS_ONE = 'https://www.newindianexpress.com/lifestyle/health/2020/may/08/i-want-to-see-a-better-me-post-covid-19-zaggle-founder-raj-n-phani-2140658.html';
export const LINK_NEWS_TWO = 'https://www.business-standard.com/article/pti-stories/fintech-startup-zaggle-ties-up-with-visa-for-innovative-paymentssolutions-for-smes-120052300687_1.html';
export const LINK_NEWS_THREE = 'https://www.thehindu.com/business/zaggle-visa-tie-up-for-sme-payments/article31660334.ece';
export const LINK_NEWS_FOUR = 'https://issuu.com/connectainnovation/docs/digital_first_magazine_technopreneurs_2021_issue_f/62';
export const LINK_NEWS_FIVE = 'https://menafn.com/1101288744/Zaggle-promoter-Raj-N-among-the-Most-Promising-Business-Leaders-of-Asia-released-at-The-Economic-Times-Asian-Business-Leaders-Conclave-2020';
export const LINK_NEWS_SIX = 'https://timesglobalnews.blogspot.com/2020/11/zaggle-wins-best-fintech-corporate.html?m=1';
export const LINK_NEWS_SEVEN = 'https://timesofindia.indiatimes.com/business/startups/companies/meet-hyderabads-soonicorns/articleshow/89767697.cms';
export const LINK_NEWS_EIGHT = 'https://bwdisrupt.businessworld.in/article/Zaggle-Partners-With-EarlySalary/16-11-2021-412114/';
export const LINK_NEWS_NINE = 'https://hr.economictimes.indiatimes.com/news/industry/arundhoti-banerjee-joins-zaggle-as-chief-operating-officer/85857816';
export const LINK_NEWS_TEN = 'https://www.pymnts.com/news/b2b-payments/2022/indian-fintech-zaggle-launches-accounts-payable-credit-card-payments-platform/';
export const LINK_NEWS_ELEVEN = 'https://menafn.com/1101631783/Zaggle-Wins-the-Best-Employee-Engagement-Award-in-The-B2B-Segment-at-the-29th-Edition-of-World-HRD-Congress-Awards-2021';
/**
 * @description all constants for the Alerts
 */
export const ALERT_PASSWORD_NOT_MATCH = 'Password does not match';
export const ALERT_PASSWORD_UPDATED = 'Password updated successfully ';
export const ALERT_PROFILE_UPDATED = 'Profile updated successfully ';
export const ALERT_CHOOSE_VARIATION = 'Please choose Value';
export const ALERT_LOGIN_REQUIRED = 'Login Required';
export const ALERT_CART_ITEM_ADDED_SUCCESS = 'Item added to your cart';
export const ALERT_CART_ITEM_REMOVED_SUCCESS = 'Cart item removed';
export const ALERT_PAYMENT_INIT = 'Are you sure you want to place the order?';
export const ALERT_PAYMENT_PROCESS = 'Please wait while we redirect you to the payment page';
export const ALERT_SIGNUP_OTP_VERIFIED = 'Congrats! You have been signed up';
export const ALERT_SEARCH_TYPE = 'Select search type';
export const ALERT_LOGOUT_SUCCESS = 'You have been logged out';
export const ADDRESS_UPDATE_SUCCESS = 'Address updated successfully';
export const QUANTITY_REQ = 'Please enter quantity';
export const PASSWORD_MATCH = 'Password does not match';
export const PASSWORD_RESET_SUCCESS = 'Password reset successfully.';
export const ALERT_ZSC_ADDED = 'ZSC added to your account';
export const ALERT_ZSC_ACTIVATION = 'Congratulations! Your Zaggle Card has been successfully activated';
export const ALERT_DEFAULT = 'Unable to fetch details. Please try again later';
export const ALERT_BOOKING_VALIDATION = 'Booking date should be greater than or equal to current date';
export const ADDRESS_DELETE_SUCCESS = 'Address deleted successfully';
export const PLAN_PARTY_SUCCESS = 'Thank you for placing a request, we will get back to you soon.';
export const ALERT_SIGNUP = 'An OTP has been sent to your phone.';
export const ALERT_BOOKING_CANCELED = 'Booking is successfully canceled';
export const ALERT_DEFAULT_ERROR = 'Unable to process request please try after sometime';
export const ALERT_ORDRER_NOT_AVAILABLE = 'Order not available';
export const ALERT_SELECT_PAYMENT_GATEWAY = 'Please select a payment mode';
export const ALERT_DATE_VALIDATION = 'The End Date should be greater than the Start Date. Please try again.';
export const ALERT_SUBSCRIBED_SUCCESS = 'Successfully Subscribed';
export const ALERT_PIN_VALIDATION = 'Invalid pin, please follow the instructions';
export const ALERT_FIELD_REQUIRED = 'Please fill required fields';
export const ALERT_PIN_UPDATED = 'PIN updated successfully!';
export const ALERT_PIN_MINIMUM_DIGITS = 'PIN should be minimum 4 digits!';
export const ALERT_IPIN_MINIMUM_DIGITS = 'PIN should be minimum 8 digits!';
export const ALERT_OTP_MINIMUM_DIGITS = 'OTP Should be minimum 6 digits!';
export const ALERT_CARD_ACCOUNT_CREATION = 'Please Complete Yes Bank Account Registration First !';
export const ALERT_CONTACT_SAVED = {
  SUCCESS: 'Form Submitted Successfully! We will contact you shortly!',
  FAILURE: 'Please provide valid details',
};
export const ALERT_DATE_VALIDATION_RESTRICT = 'From Date or To Date cannot be a future Date';
export const ALERT_DATE_VALIDATION_REQUEST_STATEMENT = 'Please Select The Date Range';
/**
 * @description date formats
 */
export const DATE_DDMMYYY = 'DDMMYYYY';
export const DATE_YYYYMMDD = 'YYYYMMDD';
export const DATE_DDMMMYYYY = 'DDMMMYYYY';
export const DATE_FORWARD = '/';
export const DATE_DASH = '-';
export const DATE_DEAL_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_DDMMYYYY = 'DD-MM-YYYY';
export const DATE_DEAL_TIME_FORMAT = 'hh:mm A';
export const DATE_DEAL_END_TIME = '11:00 PM';
export const PHONE_RESTAURANT_CUSTOMER_SUPPORT = 9848041795;
export const PHONE_CUSTOMER_SUPPORT = 18605003748;
export const ZAGGLE_EMAIL_ID = 'mailTo:team@zaggle.in';
export const ZAGGLE_TOLL_FREE_NUM = 'tel:1860 500 1231';
export const DATE_FORMAT_MMYY = 'MM/YY';


/**
 * @function creating dynamic links
 * @borrows LINK_
 */
/** @arg {*string} selectedCity */
export const GET_RESTAURANT_LIST_LINK = (selectedCity) => (`${LINK_RESTAURANTS}/${selectedCity.toLowerCase()}-restaurants`);
export const GET_LINK_CONFIRM = (confirmType, status = false) => (`${LINK_CONFIRM}/${confirmType}?status=${status}`);

const CONTANTS = {
  ...ROUTE_CONSTANTS,
};
export {
  LINK_ACCOUNT_CREATION, LINK_ACCOUNT_ACTIVATE,
  CONTANTS,
  LINK_PROPEL_CORPORATE_GIFITING_HOME,
};

export const YES_BANK_PHYSICAL = '/card-details/physical';
export const YES_BANK_VIRTUAL = '/card-details/virtual';
export const NSDL_PHYSICAL = '/card-details-nsdl/physical';
export const NSDL_VIRTUAL = '/card-details-nsdl/virtual';

export const YSC_BANK_LIMITS = '/ysc/transaction_limits';
export const NSDL_BANK_LIMITS = '/nsdl/transaction-limits';
export const INDUSIND_REQUEST_STATEMENT = '/request_statement';
export const YES_REQUEST_STATEMENT = '/yes_bank/request_statement';
export const YES_BANK_WEARABLES_FAQS = '/yes-bank-wearables/faq';
export const NSDL_REQUEST_STATEMENT = '/nsdl/request_statement';
export const YES_BANK_LIMITS = '/yes-bank/transaction-limits';
export const INDUSIND_MIN_KYC = '/indusind/min_kyc';
export const YSC_BLOCK_CARD = '/ysc/block-card';
export const YSC_LOCK_CARD = '/ysc/lock-card';
export const YSC_UNLOCK_CARD = '/ysc/unlock-card';
export const YBL_EXISTING_USERS = '/ybl/existing-users';
export const YES_BANK_CARD_RENEWAL_MANAGEMENT = '/ybl/card-renewal';
export const YSC_WALLET_LOCK_UNLOCK = '/ysc/wallet_lock_unlock';
export const YES_BANK_REPLACE_CARD_PATH = '/yes-bank/replace-card';
export const INDUSIND_BANK_ZINGER_CARDS_FAQS = '/indusind-zinger-cards/faqs';
export const YES_BANK_FAQS = '/yes-bank/faqs';
export const INDUSIND_BANK_KUBER_CARDS_FAQS = '/indusind-kuber-cards/faqs';




// WEBPACK FOOTER //
// client/devUtils/constants.js